<template>
  <li class="most-read-item">
    <NuxtLink
      :to="url"
      :external="isErrorLayout"
      @click="handleClick(title, props.item.slug)"
      @click.middle="handleClick(title, props.item.slug)"
    >
      <div class="most-read-item-content">
        <h3 class="most-read-item-title">{{ title }}</h3>
        <time class="most-read-item-date" :datetime="date">{{ formattedDate }}</time>
      </div>
    </NuxtLink>
  </li>
</template>

<script setup lang="ts">
interface IProps {
  item: {
    title: string;
    publishTime: string;
    updateTime: string;
    slug: string;
    articleType?: string;
    externalUrl?: string;
  };
  isErrorLayout?: boolean;
}

const props = defineProps<IProps>();

const { title, url, date, formattedDate } = useArticleData(props.item);

const handleClick = (linkText: string | undefined, linkUrl: string | undefined) => {
  gtmTrackEvent({
    linkAnalyticsTag: 'section-most-read',
    linkText,
    linkUrl,
  });
};
</script>

<style scoped lang="postcss">
.most-read-item {
  --most-read-item-height: 98px;
  --most-read-item-number-height: 104px;
  --most-read-item-number-font-size: 104px;

  display: flex;
  flex-direction: column;
  padding-left: var(--unit-44);
  padding-top: var(--unit-12);
  position: relative;
  min-height: var(--most-read-item-height);

  &::before {
    content: attr(data-index);
    color: hsla(var(--color-primary-200), 0.5);
    font-size: var(--most-read-item-number-font-size);
    font-style: normal;
    font-weight: 800;
    line-height: 100%;
    display: flex;
    width: 78px;
    height: var(--most-read-item-number-height);
    flex-direction: column;
    align-items: center;
    position: absolute;
    left: -4px;
    top: -6px;
  }

  @media (--lg-viewport) {
    --most-read-item-height: 114px;
    --most-read-item-number-font-size: 112px;
    --most-read-item-number-height: 126px;

    &:nth-child(1) {
      order: 1;
    }

    &:nth-child(2) {
      order: 3;
    }

    &:nth-child(3) {
      order: 5;
    }

    &:nth-child(4) {
      order: 2;
    }

    &:nth-child(5) {
      order: 4;
    }
  }
}

.most-read-item-content {
  display: flex;
  flex-direction: column;
  gap: var(--unit-6);
}

.most-read-item-title,
.most-read-item-date {
  position: relative;
}

.most-read-item-title {
  color: hsl(var(--color-primary-950));
  @add-mixin title-md;
}

.most-read-item-date {
  color: hsl(var(--color-primary-600));
  @add-mixin label-md;
}
</style>
